import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["id", "viewType", "header", "items", "largeCard"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import Carousel from "@/components/Carousel";
import Grid from "@/components/Grid";
import List from "@/components/List";
import ListRow from "@/components/Row/ListRow/index";
import PickupListRow from "@/components/Row/PickupListRow/index";
import Slider from "@/components/Slider";
import { GRID_PAGE_LIMIT, LIST_PAGE_LIMIT } from "@/lib/constants";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function PaletteContent(_ref) {
  let {
      id,
      viewType = "slider",
      header,
      items,
      largeCard
    } = _ref,
    result = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [viewType === "carousel" && /*#__PURE__*/_jsx(Carousel, {
      items: items.data
    }, `palette-${id}-carousel`), viewType === "slider" && /*#__PURE__*/_jsx(Slider, _objectSpread(_objectSpread({}, result), {}, {
      header: header,
      items: items,
      largeCard: largeCard
    }), `palette-${id}-slider`), viewType === "grid" && /*#__PURE__*/_jsx(Grid, _objectSpread(_objectSpread({}, result), {}, {
      viewTypeClassName: viewType,
      header: header,
      items: items,
      limit: GRID_PAGE_LIMIT
    }), `palette-${id}-grid`), viewType === "pickuplist" && /*#__PURE__*/_jsx(List, _objectSpread(_objectSpread({}, result), {}, {
      viewTypeClassName: viewType,
      header: header,
      itemComponent: PickupListRow,
      items: items,
      limit: LIST_PAGE_LIMIT
    }), `palette-${id}-pickuplist`), viewType === "list" && /*#__PURE__*/_jsx(List, _objectSpread(_objectSpread({}, result), {}, {
      viewTypeClassName: viewType,
      header: header,
      itemComponent: ListRow,
      items: items,
      limit: LIST_PAGE_LIMIT
    }), `palette-${id}-list`)]
  });
}